import axios from "axios";
import { Navigate } from "react-router-dom";

export const load_user_list = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/accounts_api/users_list/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}
export const load_users_short = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/accounts_api/users/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

export const load_user_data_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/accounts_api/user/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const register_profile = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };
    function replaceEmptyWithNull(obj) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
          key,
          value === "" ? null : value
        ])
      );
    }

    const updatedData = replaceEmptyWithNull(data);
    const body = JSON.stringify(updatedData);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/accounts_api/register/`, body, config);

      return response.data;
    } catch (err) {
      return err;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

export const update_profile = async (data, id) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/accounts_api/user/${id}`, body, config);

      return response.data;
    } catch (err) {
      return err;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

// User File management
export const load_user_file_list = async (userId) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/accounts_api/user/${userId}/archivos/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}
export const upload_user_file = async (userId, file) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
      },
    };
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/accounts_api/user/${userId}/archivos/`, formData, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}
export const delete_user_file = async (userId, fileId) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };

    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/accounts_api/user/${userId}/archivos/${fileId}`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}